
















import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import PaymentMethodMixin from './PaymentMethodMixin';
import { PaymentSubmission } from '@/Payment/PaymentSubmission';

const component = mixins(LocationBasedMixin, PaymentMethodMixin).extend({
  data() {
    return {
      checkNumber: null as string | null,
    };
  },
  computed: {
    submission(): PaymentSubmission<any> {
      return {
        toPay: this.recordsToPay,
        customer: this.customer,
        paymentMethod: {
          checkNumber: this.checkNumber,
          paymentSource: this.source
        }
      };
    }
  },
});

export default component;
